var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.booking.is_offer
    ? _c("div", { staticClass: "dashboard-block" }, [
        _c("h2", [_vm._v("Admin Options")]),
        _vm._v(" "),
        _c("div", { staticClass: "panel" }, [
          _c("div", { staticClass: "panel-body" }, [
            _vm.$requestFormConfig.show_commission && _vm.monetaryCurrency
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-4" }, [
                    _c("h3", [_vm._v(_vm._s(_vm.clientName) + " Commission")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-8" }, [
                    _c(
                      "div",
                      {
                        class: _vm.hasErrorClass(
                          _vm.$v.stateCommissionRate,
                          "form-group"
                        ),
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-5 col-md-5" },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.$v.stateCommissionRate.$model,
                                      expression:
                                        "$v.stateCommissionRate.$model",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    name: "commission_rate",
                                    type: "number",
                                    min: "0",
                                    autocomplete: "off",
                                    disabled: !!_vm.stateCommissionDollar,
                                  },
                                  domProps: {
                                    value: _vm.$v.stateCommissionRate.$model,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.$v.stateCommissionRate,
                                        "$model",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm._m(0),
                              ]),
                              _vm._v(" "),
                              _c("vuelidate-help", {
                                attrs: {
                                  field: _vm.$v.stateCommissionRate,
                                  label: "Commission rate",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-sm-1 col-md-1",
                              staticStyle: {
                                padding: "0",
                                "padding-top": "10px",
                                "text-align": "center",
                              },
                            },
                            [_vm._v("OR")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-5 col-md-5" }, [
                            _c(
                              "div",
                              {
                                class: _vm.hasErrorClass(
                                  _vm.$v.stateCommissionDollar,
                                  "form-group"
                                ),
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.$v.stateCommissionDollar.$model,
                                        expression:
                                          "$v.stateCommissionDollar.$model",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      name: "commission_dollar",
                                      type: "text",
                                      disabled: !!_vm.stateCommissionRate,
                                    },
                                    domProps: {
                                      value:
                                        _vm.$v.stateCommissionDollar.$model,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.$v.stateCommissionDollar,
                                          "$model",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("vuelidate-help", {
                                  attrs: {
                                    field: _vm.$v.stateCommissionDollar,
                                    label: "Commission dollar",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.$vlastMode
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(
                            _vm._s(_vm._f("sentenceCase")(_vm.$starLabel)) +
                              " Expiration"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("sentenceCase")(_vm.$starLabelPlural)
                            ) +
                            " Can Expire:  \n            "
                        ),
                        _c("toggle-button", {
                          attrs: {
                            sync: true,
                            labels: { checked: "Yes", unchecked: "No" },
                            color: {
                              checked: _vm.$brandPrimary,
                              unchecked: "#b7b7b7",
                            },
                          },
                          model: {
                            value: _vm.booking.talent_expire,
                            callback: function ($$v) {
                              _vm.$set(_vm.booking, "talent_expire", $$v)
                            },
                            expression: "booking.talent_expire",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(
                            _vm._s(_vm._f("sentenceCase")(_vm.$starLabel)) +
                              " Commenting"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("sentenceCase")(_vm.$starLabelPlural)
                            ) +
                            " Can Comment:  \n            "
                        ),
                        _c("toggle-button", {
                          attrs: {
                            sync: true,
                            labels: { checked: "Yes", unchecked: "No" },
                            color: {
                              checked: _vm.$brandPrimary,
                              unchecked: "#b7b7b7",
                            },
                          },
                          model: {
                            value: _vm.booking.talent_can_comment,
                            callback: function ($$v) {
                              _vm.$set(_vm.booking, "talent_can_comment", $$v)
                            },
                            expression: "booking.talent_can_comment",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v("Uploading Files"),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n            Client can upload files:  \n            "
                        ),
                        _c("toggle-button", {
                          attrs: {
                            sync: true,
                            labels: { checked: "Yes", unchecked: "No" },
                            color: {
                              checked: _vm.$brandPrimary,
                              unchecked: "#b7b7b7",
                            },
                          },
                          model: {
                            value: _vm.booking.can_upload_files,
                            callback: function ($$v) {
                              _vm.$set(_vm.booking, "can_upload_files", $$v)
                            },
                            expression: "booking.can_upload_files",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.$vlastMode
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-3" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v("Request Expiration"),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n            Request Can Expire:  \n            "
                        ),
                        _c("toggle-button", {
                          attrs: {
                            sync: true,
                            labels: { checked: "Yes", unchecked: "No" },
                            color: {
                              checked: _vm.$brandPrimary,
                              unchecked: "#b7b7b7",
                            },
                          },
                          model: {
                            value: _vm.booking.expires,
                            callback: function ($$v) {
                              _vm.$set(_vm.booking, "expires", $$v)
                            },
                            expression: "booking.expires",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.booking.expires
                    ? _c("div", { staticClass: "col-sm-3" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label"),
                            _vm._v(" "),
                            _c("flat-pickr", {
                              staticClass: "form-control pickdate",
                              attrs: {
                                config: _vm.flatPickerDateConfig,
                                placeholder: "Please Select",
                                name: "date",
                              },
                              model: {
                                value: _vm.booking.billboard_expiry_date,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.booking,
                                    "billboard_expiry_date",
                                    $$v
                                  )
                                },
                                expression: "booking.billboard_expiry_date",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$userIsGlobalAdmin && _vm.regionOptions.length > 1
              ? _c(
                  "div",
                  {
                    class: _vm.hasErrorClass(_vm.$v.stateRegion, "form-group"),
                  },
                  [
                    _c("h3", [_vm._v("Region")]),
                    _vm._v(" "),
                    _c("selectize", {
                      staticClass: "selectize selectize-single",
                      attrs: { name: "timezone", options: _vm.regionOptions },
                      model: {
                        value: _vm.$v.stateRegion.$model,
                        callback: function ($$v) {
                          _vm.$set(_vm.$v.stateRegion, "$model", $$v)
                        },
                        expression: "$v.stateRegion.$model",
                      },
                    }),
                    _vm._v(" "),
                    _c("vuelidate-help", {
                      attrs: { field: _vm.$v.stateRegion, label: "Region" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6 col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "ladda-button",
                      {
                        staticClass: "btn m-t-label btn-success",
                        attrs: { click: _vm.handleSaveCommissionRateCallback },
                      },
                      [_vm._v("\n              Save Changes\n            ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-addon" }, [
      _c("i", { staticClass: "fa fa-percent" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-addon" }, [
      _c("i", { staticClass: "fa fa-usd" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }